import React from "react";
import PropTypes from "prop-types";

const NoData = ({ page }) => (
  <div>
    <hr />
    <div style={{ textAlign: "center" }}>
      {page === "open" ? (
        <p className="grey-text center-text">
          No Open Sub Requests found. To request a sub for your shift, visit
          your&nbsp;
          <a href="/my_schedule" className="styled-link">
            My Schedule page
          </a>, open a shift, and click "REQUEST SUB".
        </p>
      ) : page === "pending" ? (
        <p className="grey-text center-text">
          No Sub Requests Pending Approval found. Visit&nbsp;
          <a href="/sub_requests" className="styled-link">
            Open Sub Requests
          </a>{" "}
          to claim a shift.
        </p>
      ) : (
        <p className="grey-text center-text">
          No Processed Sub Requests found. Visit&nbsp;
          <a href="/sub_requests_pending_approval" className="styled-link">
            Sub Request Pending Approval
          </a>{" "}
          to approve or deny a pending shift trade.
        </p>
      )}
    </div>
  </div>
);

NoData.propTypes = {
  page: PropTypes.string
};

export default NoData;
